module.exports = __webpack_public_path__ + "static/img/1.c82c877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/1.png
// module id = oo2L
// module chunks = 1 3